import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store';

import { dashboardSliceName } from './index';

export const dashboardSelector = (state: RootState): RootState[typeof dashboardSliceName] => state[dashboardSliceName];

export const accountSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.account);

export const accountSubscriptionSelector = createSelector(
  dashboardSelector,
  (dashSlice) => dashSlice.accountSubscription
);

export const payoutStatusSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.payoutStatus);

export const votePagesSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.votePages);

export const votePageCountSelector = createSelector(votePagesSelector, (votePages) => Object.keys(votePages).length);

export const getVotePageByIdSelector = (id: string) =>
  createSelector(votePagesSelector, (votePages) => votePages[id] ?? null);

export const configSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.config || {});

export const voteTypesSelector = createSelector(configSelector, (config) => config.vote_types);

export const templatesSelector = createSelector(configSelector, (config) => config.templates);

export const fieldLimitsSelector = createSelector(configSelector, (config) => config.field_limits);

export const subscriptionTypesSelector = createSelector(configSelector, (config) => config.subscription_types);

export const currenciesSelector = createSelector(configSelector, (config) => config.currencies);

export const embedWidgetsSelector = createSelector(configSelector, (config) => config.embed_widgets);

export const billingSelector = createSelector(configSelector, (config) => config.billing ?? null);

export const trialEligibleSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.trialEligible);

export const googleClientIdSelector = createSelector(configSelector, (config) => config.google_client_id || '');

export const initializingDashboardSelector = createSelector(
  dashboardSelector,
  (dashSlice) => dashSlice.initializingDashboard
);

export const votePagesFetchedSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.votePagesFetched);

export const initializedSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.initialized);

export const initializeFailedSelector = createSelector(dashboardSelector, (dashSlice) => dashSlice.initializeFailed);

export const subscriptionSelector = createSelector(
  subscriptionTypesSelector,
  accountSubscriptionSelector,
  (subscriptionTypes, accountSubscription) =>
    subscriptionTypes?.[accountSubscription?.type || 'free'] || subscriptionTypes?.free || null
);

export const userLimitsSelector = createSelector(subscriptionSelector, (subscription) => subscription?.limits);

export const categoryLimitSelector = createSelector(userLimitsSelector, (limits) => limits?.category || 0);

export const nomineeLimitSelector = createSelector(userLimitsSelector, (limits) => limits?.nominee || 0);

export const votePageLimitSelector = createSelector(userLimitsSelector, (limits) => limits?.vote_page || 0);
